export const propertyRentCities = [
  "Praha",
  "Brno",
  "Ostrava",
  "Plzeň",
  "Liberec",
  "Olomouc",
  "České Budějovice",
  "Ústí nad Labem",
  "Hradec Králové",
  "Pardubice",
  "Zlín",
  "Havířov",
  "Kladno",
  "Most",
  "Opava",
  "Frýdek-Místek",
  "Karviná",
  "Jihlava",
  "Teplice",
  "Děčín",
];

export const flatRentCities = [
  "Praha",
  "Brno",
  "Ostrava",
  "Plzeň",
  "Liberec",
  "Olomouc",
  "Ústí nad Labem",
  "Hradec Králové",
  "České Budějovice",
  "Pardubice",
  "Havířov",
  "Zlín",
  "Kladno",
  "Most",
  "Karviná",
  "Opava",
  "Frýdek-Místek",
  "Karlovy Vary",
  "Teplice",
  "Děčín",
  "Jihlava",
  "Chomutov",
  "Přerov",
  "Jablonec nad Nisou",
  "Prostějov",
  "Mladá Boleslav",
  "Česká Lípa",
  "Třebíč",
  "Třinec",
  "Tábor",
  "Znojmo",
  "Příbram",
  "Cheb",
  "Orlová",
  "Trutnov",
  "Kolín",
  "Písek",
  "Kroměříž",
  "Vsetín",
  "Šumperk",
];

export const houseRentCities = [
  "Praha",
  "Brno",
  "Ostrava",
  "Olomouc",
  "Pardubice",
  "České Budějovice",
  "Zlín",
  "Mladá Boleslav",
  "Plzeň",
  "Most",
  "Liberec",
  "Kladno",
  "Hradec Králové",
  "Chrudim",
  "Nymburk",
  "Frýdek Místek",
  "Prostějov",
  "Jihlava",
  "Znojmo",
  "Ústí nad Labem",
  "Česká Lípa",
  "Říčany",
  "Příbram",
  "Mělník",
  "Louny",
  "Litoměřice",
  "Kutná Hora",
  "Klatovy",
  "Strakonice",
  "Hodonín",
  "Kolín",
  "Děčín",
  "Jablonec nad Nisou",
  "Domažlice",
  "Trutnov",
  "Havířov",
  "Břeclav",
  "Vyškov",
  "Kroměříž",
  "Tábor",
];

export const propertySaleCities = [
  "Praha",
  "Brno",
  "Ostrava",
  "Plzeň",
  "Liberec",
  "Olomouc",
  "České Budějovice",
  "Ústí nad Labem",
  "Hradec Králové",
  "Pardubice",
  "Zlín",
  "Havířov",
  "Kladno",
  "Most",
  "Opava",
  "Frýdek-Místek",
  "Karviná",
  "Jihlava",
  "Teplice",
  "Děčín",
];

export const flatSaleCities = [
  "Praha",
  "Brno",
  "Ostrava",
  "Olomouc",
  "Liberec",
  "Pardubice",
  "Teplice",
  "České Budějovice",
  "Plzeň",
  "Hradec Králové",
  "Chrudim",
  "Jihlava",
  "Kladno",
  "Mladá Boleslav",
  "Kolín",
  "Třebíč",
  "Valašské Meziříčí",
  "Ústí nad Labem",
  "Chomutov",
  "Trutnov",
  "Strakonice",
  "Opava",
  "Jablonec nad Nisou",
  "Frýdek Místek",
  "Karlovy Vary",
  "Šumperk",
  "Přerov",
  "Uherské Hradiště",
  "Blansko",
  "Zlín",
  "Tábor",
  "Kadaň",
  "Sázava",
  "Česká Lípa",
  "Třeboň",
  "Mariánské Lázně",
  "Hranice",
  "Poděbrady",
  "Prostějov",
  "Rakovník",
  "Klášterec nad Ohří",
];

export const houseSaleCities = [
  "Praha",
  "Brno",
  "Olomouc",
  "Opava",
  "Uherské Hradiště",
  "Ostrava",
  "Znojmo",
  "České Budějovice",
  "Litoměřice",
  "Tábor",
  "Vysočina",
  "Hostivice",
  "Beroun",
  "Jindřichův Hradec",
  "Nymburk",
  "Valašské Klobouky",
  "Slavkov u Brna",
  "Rakovník",
  "Uherský Brod",
  "Nový Jičín",
  "Havlíčkův Brod",
  "Cheb",
  "Tišnov",
  "Nové Město na Moravě",
  "Sázava",
  "Bojkovice",
  "Týniště nad Orlicí",
  "Vimperk",
  "Nebušice",
  "Bělá pod Bezdězem",
  "Strakonice",
  "Mladá Boleslav",
  "Nupaky",
  "Opočno",
  "Strančice",
  "Rychnov nad Kněžnou",
  "Zdice",
  "Hluboká nad Vltavou",
  "Malá Morávka",
  "Hořice",
];

export const studentCities = [
  "Praha",
  "Brno",
  "Ostrava",
  "Plzeň",
  "Liberec",
  "Olomouc",
  "Ústí nad Labem",
  "Hradec Králové",
  "České Budějovice",
  "Pardubice",
  "Zlín",
  "Opava",
];

export const prague = [
  "Praha, Bohnice",
  "Praha, Braník",
  "Praha, Břevnov",
  "Praha, Bubeneč",
  "Praha, Čakovice",
  "Praha, Černý Most",
  "Praha, Čimice",
  "Praha, Dejvice",
  "Praha, Háje",
  "Praha, Hloubětín",
  "Praha, Hlubočepy",
  "Praha, Hodkovičky",
  "Praha, Holešovice",
  "Praha, Horní Počernice",
  "Praha, Hostivař",
  "Praha, Hradčany",
  "Praha, Chodov",
  "Praha, Jinonice",
  "Praha, Josefov",
  "Praha, Kamýk",
  "Praha, Karlín",
  "Praha, Kbely",
  "Praha, Kobylisy",
  "Praha, Košíře",
  "Praha, Krč",
  "Praha, Kunratice",
  "Praha, Kyje",
  "Praha, Letňany",
  "Praha, Lhotka",
  "Praha, Libeň",
  "Praha, Liboc",
  "Praha, Malá Strana",
  "Praha, Malešice",
  "Praha, Michle",
  "Praha, Modřany",
  "Praha, Nové Město",
  "Praha, Nusle",
  "Praha, Podolí",
  "Praha, Prosek",
  "Praha, Radotín",
  "Praha, Ruzyně",
  "Praha, Řepy",
  "Praha, Smíchov",
  "Praha, Staré Město",
  "Praha, Stodůlky",
  "Praha, Strašnice",
  "Praha, Střešovice",
  "Praha, Střížkov",
  "Praha, Suchdol",
  "Praha, Troja",
  "Praha, Újezd",
  "Praha, Vinohrady",
  "Praha, Vokovice",
  "Praha, Vršovice",
  "Praha, Vysočany",
  "Praha, Vyšehrad",
  "Praha, Záběhlice",
  "Praha, Zbraslav",
  "Praha, Zličín",
  "Praha, Žižkov",
];
